import { render, staticRenderFns } from "./add-list-to-power-dialer.vue?vue&type=template&id=812a24b2"
import script from "./add-list-to-power-dialer.vue?vue&type=script&lang=js"
export * from "./add-list-to-power-dialer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports